import { TranslatableText, Translate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { StyledTooltipText } from './PatientPhoneNotificationTooltipText.styled';

type PhoneNotificationTooltipTextProps = {
   readonly header: TranslatableText;
   readonly messages: string[];
};

export const PhoneNotificationTooltipText = (props: PhoneNotificationTooltipTextProps): JSX.Element => (
   <StyledTooltipText>
      <StyledFlex direction='column' gap={'12px'}>
         <Translate>{props.header}</Translate>
         {props.messages.map((message, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index}>{`"${message}"`}</span>
         ))}
      </StyledFlex>
   </StyledTooltipText>
);
